import { Action } from 'redux';
import { initializeState } from 'src/utils/Initial';
import { isType } from 'typescript-fsa';
import * as Actions from '../actions/quickModeContens';

export interface IQuickModeContentsState {
	courseFolder: string;
	courseName: string;
	currentItem: Actions.ICurrentItem | undefined;
	indexTreeOpen: boolean;
	text: Actions.IFileInfo[];
	test: Actions.ITestInfo | null;
	viewItem: [];
	testFile: Actions.ITestFileInfo;
	manageOrgList: Actions.IManageOrg[];
	orgId: string;
	fileSize: string;
}
const initialState: IQuickModeContentsState = {
	courseFolder: '',
	courseName: '新規コース',
	currentItem: undefined,
	fileSize: '',
	indexTreeOpen: false,
	manageOrgList: [],
	orgId: '',
	test: null,
	testFile: {
		file: null,
		fileName: '',
	},
	text: [],
	viewItem: [],
};

const quickModeContents = (state: IQuickModeContentsState, action: Action) => {
	if (!state) {
		// State初期化処理
		state = initialState;
		state = initializeState(state);
	}

	if (isType(action, Actions.setText)) {
		return {
			...state,
			text: action.payload.files,
		};
	}
	if (isType(action, Actions.setViewItem)) {
		return {
			...state,
			viewItem: action.payload.viewItem,
		};
	}
	if (isType(action, Actions.setCurrentItem)) {
		const newState = { ...state };
		const currentItem: Actions.ICurrentItem = {
			kind: action.payload.kind,
			page: action.payload.page,
		};
		newState.currentItem = currentItem;
		return newState;
	}
	if (isType(action, Actions.setIndexTree)) {
		return {
			...state,
			indexTreeOpen: !state.indexTreeOpen,
		};
	}

	if (isType(action, Actions.setCourseFolder)) {
		return {
			...state,
			courseFolder: action.payload.courseFolder,
			fileSize: action.payload.fileSize,
		};
	}

	if (isType(action, Actions.setTestFile)) {
		return {
			...state,
			testFile: {
				file: action.payload.file,
				fileName: action.payload.fileName,
			},
		};
	}

	if (isType(action, Actions.setCourseName)) {
		return {
			...state,
			courseName: action.payload.courseName,
		};
	}

	if (isType(action, Actions.setTestData)) {
		const testTmp: Actions.ITestInfo | null = action.payload.templateData;
		if (testTmp) {
			let totalScore = 0;
			if (testTmp.questions.length > 0) {
				testTmp.questions.forEach((question, i) => {
					if (i !== testTmp.numberOfQuestions - 1) {
						question.questionScore = Math.floor(
							100 / testTmp.numberOfQuestions
						);
						totalScore = totalScore + question.questionScore;
					} else {
						question.questionScore = 100 - totalScore;
					}
					question.options.forEach((opt, j) => {
						opt.value = j.toString();
					});
				});
			}
		}
		return {
			...state,
			test: testTmp,
		};
	}

	if (isType(action, Actions.setManageOrg)) {
		return {
			...state,
			manageOrgList: action.payload.manageOrgList,
		};
	}

	if (isType(action, Actions.setOrgId)) {
		return {
			...state,
			orgId: action.payload.orgId,
		};
	}
	if (isType(action, Actions.reSetCurrentItem)) {
		return {
			...state,
			currentItem: undefined,
		};
	}
	return state;
};

export default quickModeContents;



// WEBPACK FOOTER //
// ./src/reducers/quickModeContents.ts